<script>
export default {
  name: "PricingBoxes",
  props: {
    trial_used: {
      type: Boolean,
      default: false
    },
    linklabel:{
        type: String,
        default: 'Get started with'
      },
    instant_checkout: {
      type: Boolean,
      default: false
    },
    linkpath:{
        type: String,
        default: 'registration/'
      },
    data: {
      type: Array,
    }
  }
}
</script>

<template>
  <div class="row g-1 justify-content-center">
    <div v-for="(item, index) in data" :key="`pr-b${index}`" class="col-60 col-lg-15" :class="{'col-lg-20': data.length < 4}">
        <PricingBox :data="item" :linklabel="linklabel" :linkpath="linkpath" :trial_used="trial_used" :instant_checkout="instant_checkout"/>
    </div>
  </div>
</template>
